export default __webpack_public_path__ + "static/media/dtsd5168-4.85c6ae42.png";